enum OutlineAddFields {
	NAME = "name",
	POSITION = "position",
	TARGET = "target",
	COLOR = "color",
	BOLD = "bold",
	ITALIC = "italic",
	OPEN = "open",
	ZOOM = "zoom",
	ACTION = "action",
	ACTION_JAVASCRIPT = "action_javascript",
	ACTION_URI = "action_uri",
	EXECUTE_ACTION = "execute_action",
	EXECUTE_CUSTOM = "execute_custom",
	GO_TO_PAGE = "go_to_page",
	GO_TO_TOP_OFFSET = "go_to_top_offset",
	GO_TO_BOTTOM_OFFSET = "go_to_bottom_offset",
	GO_TO_LEFT_OFFSET = "go_to_left_offset",
	GO_TO_RIGHT_OFFSET = "go_to_right_offset",
	GO_TO_ZOOM = "go_to_zoom",
	LIST = "list"
}

export default OutlineAddFields;